import { DEFAULT_REGISTER_URL } from '@pb26/shared';

export const REGISTER_URL =
  import.meta.env.VITE_REGISTER_URL?.trim() || DEFAULT_REGISTER_URL;
